import React from 'react';
import './Footer.css';
import instaIcon from '../../../assets/img/social/instagram.svg';
import waIcon from '../../../assets/img/social/whatsapp.svg';
import linkedinIcon from '../../../assets/img/social/linkedin.svg';

const Footer = () => {

    const year = new Date().getFullYear();

    return (
        <>
            <footer>
                <div className="copyright">
                    <p>Copyright &copy; Sky Servants {year}</p>
                </div>
                <div className="social">
                    {/* <a href="https://www.instagram.com/skyservants" target="_blank" rel="noreferrer"><img src={instaIcon} alt="instagram" /></a> */}
                    <a href="https://api.whatsapp.com/send?phone=573214818369" target="_blank" rel="noreferrer"><img src={waIcon} alt="whatsapp" /></a>
                    <a href="https://linkedin.com/company/sky-servants" target="_blank" rel="noreferrer"><img src={linkedinIcon} alt="linkedin" /></a>
                </div>
                <div className="contact">
                    <p>skyservants@gmail.com</p>
                </div>
            </footer>
        </>
    );
};

export default Footer;